import axios from 'axios';
import { baseUrl } from './config';
import { ILandModel } from '../models/Land';

export const getLandById = async (landId: string) => {
    const url = `${baseUrl}/lands/${landId}`;
    const res = await axios.get(url);
    return res.data.data.Items[0] as ILandModel;
};
